var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef, useState } from 'react';
import SwiperCore, { Virtual, Navigation } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import Card from './Card';
import Cardv2 from './Cardv2';
import CarouselArrow from './CarouselArrow';
import './Carousel.scss';
SwiperCore.use([Virtual, Navigation]);
import '../../../lib/styles/swiper.scss';
import { useWindowSize } from '../../../hooks/useWindowSize';
var SwiperCarousel = function (_a) {
    var cardsArray = _a.cardsArray;
    var width = useWindowSize()[0];
    var isMobile = width < 768;
    var isTablet = window.innerWidth <= 1020;
    var isDesktop = window.innerWidth >= 1440;
    var _b = useState(0), activeMobile = _b[0], setActiveMobile = _b[1];
    var navigationPrevRef = useRef(null);
    var navigationNextRef = useRef(null);
    // const swiper = React.createRef();
    var _c = useState({}), my_swiper = _c[0], set_my_swiper = _c[1];
    var renderCards = cardsArray.map(function (contentProps, index) {
        if (isMobile) {
            return (_jsx(Card, __assign({}, contentProps, { index: index, activeMobile: activeMobile, setActiveMobile: setActiveMobile }), void 0));
        }
        else {
            return (_jsx(SwiperSlide, { children: _jsx(Card, __assign({}, contentProps, { index: index }), void 0) }, "card-" + index));
        }
    });
    var renderCardsTablet = cardsArray.map(function (contentProps, index) {
        if ((window.innerWidth >= 768 && cardsArray.length == 2) ||
            window.innerWidth >= 950) {
            return (_jsx(Cardv2, __assign({}, contentProps, { index: index, activeMobile: activeMobile, setActiveMobile: setActiveMobile }), void 0));
        }
        else {
            return (_jsx(SwiperSlide, { children: _jsx(Card, __assign({}, contentProps, { index: index }), void 0) }, "card-" + index));
        }
    });
    var renderCarouselArrow = ['left', 'right'].map(function (direction, index) { return (_jsx(CarouselArrow, { externalRef: !index ? navigationPrevRef : navigationNextRef, direction: direction }, direction)); });
    var onBeforeInitHandler = function (swiper) {
        swiper.params.navigation.prevEl = navigationPrevRef.current;
        swiper.params.navigation.nextEl = navigationNextRef.current;
    };
    return isMobile ? (_jsx("div", __assign({ className: "mx-auto px-6", style: { paddingTop: '16px' } }, { children: renderCards }), void 0)) : (window.innerWidth >= 768 && cardsArray.length == 2) ||
        (cardsArray.length == 3 && window.innerWidth >= 950) ? (
    // window.innerWidth>=768 || cardsArray.length == 2
    _jsx("div", __assign({ className: "mx-auto px-6 flex two-cards" }, { children: renderCardsTablet }), void 0)) : (_jsxs(Swiper
    // ref={swiper}
    , __assign({ 
        // ref={swiper}
        onInit: function (ev) {
            set_my_swiper(ev);
        }, modules: [Virtual, Navigation], navigation: true, loop: true, onBeforeInit: onBeforeInitHandler, slidesPerGroup: 1, slidesPerView: isTablet ? 3 : 4, spaceBetween: isDesktop ? 100 : 150, centeredSlides: true }, { children: [renderCards, _jsx("div", __assign({ slot: "container-end", className: "z-50 mt-10 hidden w-full justify-center space-x-4 px-6 sm:flex md:flex lg:mt-12" }, { children: renderCarouselArrow }), "asdasdasdassadd")] }), void 0));
};
export default SwiperCarousel;
